import { render, staticRenderFns } from "./SysCheckRuleList.vue?vue&type=template&id=507bdf70&scoped=true&"
import script from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
import style0 from "./SysCheckRuleList.vue?vue&type=style&index=0&id=507bdf70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bdf70",
  null
  
)

export default component.exports